<script>
    // Licensed under Gnu Public Licence version 2
    // Copyright (c) 2025 (original work) Open Assessment Technologies SA ;
    import { Button } from '@oat-sa-private/ui-elements';
    import FlyoutMenu from '../flyoutMenu/FlyoutMenu.svelte';

    export let items = [];
    export let label = 'DropdownButton';
    export let shape = 'pill';
    export let skin = 'secondary';
    export let size = 'small';
    export let divider = true;
    export let icon = 'caret-down-12';
    export let iconSide = 'right';
    export let anchoring = 'top right';

    let caller;

    let showFlyout = false; // manage open state

    function toggleFlyout() {
        showFlyout = !showFlyout;
    }
</script>

<style>
    .button-toggle {
        display: inline-block;
    }
</style>

<div bind:this={caller} class="button-toggle" class:active={showFlyout}>
    <Button {shape} {skin} {label} {size} {divider} {icon} {iconSide} on:click={toggleFlyout} />
</div>
<FlyoutMenu bind:open={showFlyout} {items} {caller} {anchoring} on:action />
